// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValidationErrors_validationErrorText__Jxj0K {
  position: absolute;
  /* font-size: 12px; */
  /* display: flex;
  align-items: center; */
  margin-top: 3px;
  transition: all 2s ease-out;
  height: 25px;
  /* width: 220px; */
  width: 100% !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  /* min-width: 250px; */
}
.ValidationErrors_validationErrorText__Jxj0K svg {
  margin-bottom: -8px;
  margin-inline-end: 4px;
}
.ValidationErrors_hide__Iyejq {
  opacity: 0;
}
.ValidationErrors_show__qz0lK {
  opacity: 1;
}
@media all and (min-width: 900px) {
  .ValidationErrors_show__qz0lK {
    animation: ValidationErrors_LargeEerrorTextAnimation__OLYoc 2s ease-in-out;
  }
}
@media all and (max-width: 900px) {
  .ValidationErrors_show__qz0lK {
    animation: ValidationErrors_smallErrorTextAnimation__AmMpj 2s ease-in-out;
  }
}
@keyframes ValidationErrors_LargeEerrorTextAnimation__OLYoc {
  0% {
    transform: translateX(-100px);
  }
  20% {
    transform: translateX(50px);
  }
  40% {
    transform: translateX(-20px);
  }
  60% {
    transform: translateX(8px);
  }
  80% {
    transform: translateX(-2px);
  }
  100% {
    transform: translateX(0px);
  }
}
@keyframes ValidationErrors_smallErrorTextAnimation__AmMpj {
  0% {
    transform: translateX(-8px);
  }
  20% {
    transform: translateX(10px);
  }
  40% {
    transform: translateX(-7px);
  }
  60% {
    transform: translateX(5px);
  }
  80% {
    transform: translateX(-2px);
  }
  100% {
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/ValidationErrors/ValidationErrors.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;wBACsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,0EAAkD;EACpD;AACF;AACA;EACE;IACE,yEAAiD;EACnD;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".validationErrorText {\r\n  position: absolute;\r\n  /* font-size: 12px; */\r\n  /* display: flex;\r\n  align-items: center; */\r\n  margin-top: 3px;\r\n  transition: all 2s ease-out;\r\n  height: 25px;\r\n  /* width: 220px; */\r\n  width: 100% !important;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  /* min-width: 250px; */\r\n}\r\n.validationErrorText svg {\r\n  margin-bottom: -8px;\r\n  margin-inline-end: 4px;\r\n}\r\n.hide {\r\n  opacity: 0;\r\n}\r\n.show {\r\n  opacity: 1;\r\n}\r\n@media all and (min-width: 900px) {\r\n  .show {\r\n    animation: LargeEerrorTextAnimation 2s ease-in-out;\r\n  }\r\n}\r\n@media all and (max-width: 900px) {\r\n  .show {\r\n    animation: smallErrorTextAnimation 2s ease-in-out;\r\n  }\r\n}\r\n@keyframes LargeEerrorTextAnimation {\r\n  0% {\r\n    transform: translateX(-100px);\r\n  }\r\n  20% {\r\n    transform: translateX(50px);\r\n  }\r\n  40% {\r\n    transform: translateX(-20px);\r\n  }\r\n  60% {\r\n    transform: translateX(8px);\r\n  }\r\n  80% {\r\n    transform: translateX(-2px);\r\n  }\r\n  100% {\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n@keyframes smallErrorTextAnimation {\r\n  0% {\r\n    transform: translateX(-8px);\r\n  }\r\n  20% {\r\n    transform: translateX(10px);\r\n  }\r\n  40% {\r\n    transform: translateX(-7px);\r\n  }\r\n  60% {\r\n    transform: translateX(5px);\r\n  }\r\n  80% {\r\n    transform: translateX(-2px);\r\n  }\r\n  100% {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"validationErrorText": `ValidationErrors_validationErrorText__Jxj0K`,
	"hide": `ValidationErrors_hide__Iyejq`,
	"show": `ValidationErrors_show__qz0lK`,
	"LargeEerrorTextAnimation": `ValidationErrors_LargeEerrorTextAnimation__OLYoc`,
	"smallErrorTextAnimation": `ValidationErrors_smallErrorTextAnimation__AmMpj`
};
export default ___CSS_LOADER_EXPORT___;
